import { createAction } from 'redux-actions'
import * as constants from './constants'

export const sendDriftAppMetric = createAction(constants.SEND_DRIFT_APP_METRIC)
export const sendDriftAppMetricPending = createAction(constants.SEND_DRIFT_APP_METRIC_PENDING)
export const sendDriftAppMetricFailed = createAction(constants.SEND_DRIFT_APP_METRIC_FAILED)
export const sendDriftAppMetricSuccess = createAction(constants.SEND_DRIFT_APP_METRIC_SUCCESS)
